module.exports = __webpack_public_path__ + "static/img/ABUIABACGAAgrr7xkQYo4MOA8wEwwAI48AE.4e77486.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ABUIABACGAAgrr7xkQYo4MOA8wEwwAI48AE.jpg
// module id = gLT7
// module chunks = 1